import React from 'react'
import Color from '../../../components/Field.Color'

import Card from './Card'
import Group from './Group'
// import Label from './Group.Label'
import Item from './Group.Item'

function Component(
    {
        fieldLayout,
        disabled,

        select,
        onChange,
    }
)
{
    return (
        <Card title="Footer" >
            <Group>
                <Item>
                    <Color 
                        disabled={disabled}
                        layout={fieldLayout}
                        label="พื้นหลัง"
                        name="footer.bgColor"
                        alpha={false}
                        value={select('footer.bgColor')}
                        onChange={onChange}
                    />
                    
                    <Color 
                        disabled={disabled}
                        layout={fieldLayout}
                        label="ตัวอักษร"
                        name="footer.color"
                        alpha={false}
                        value={select('footer.color')}
                        onChange={onChange}
                    />
                </Item>
            </Group>
        </Card>
    )
}

export default Component